import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';

import { dictionariesEntry, dictionariesColumn } from 'types';
import TableRow from './components/TableRow';

export class TableBody extends Component {
  static propTypes = {
    entries: PropTypes.arrayOf(dictionariesEntry),
    columns: PropTypes.arrayOf(dictionariesColumn),
    selection: PropTypes.arrayOf(PropTypes.string),
    focus: PropTypes.shape({
      row: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      col: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    onFocus: PropTypes.func.isRequired,
    onRemoveRow: PropTypes.func.isRequired,
    onUpdateRow: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    return (
      !_isEqual(nextProps.entries, this.props.entries) ||
      !_isEqual(nextProps.columns, this.props.columns) ||
      !_isEqual(nextProps.selection, this.props.selection) ||
      nextProps.focus !== this.props.focus
    );
  }

  render() {
    const { entries, columns, onRemoveRow } = this.props;

    return (
      <tbody>
        {entries.map((entry, index) => (
          <TableRow
            key={entry.id}
            entry={entry}
            entryIndex={index}
            columns={columns}
            selection={this.props.selection}
            focus={this.props.focus}
            onFocus={this.props.onFocus}
            onRemoveRow={onRemoveRow}
            onUpdateRow={this.props.onUpdateRow}
            onSave={this.props.onSave}
            onSelect={this.props.onSelect}
          />
        ))}
      </tbody>
    );
  }
}

export default TableBody;
